{
  "survey-number": "Survey Number",
  "survey-information": "Survey Information",
  "land-only": "Land Only",
  "leasehold": "Leasehold",
  "commercial-le": "Commercial Leasehold",
  "manufactured": "Manufactured Home",
  "mobile-home": "Mobile Home",
  "wetlands": "Wetlands"
}
